import script from "./CreateMemberView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateMemberView.vue?vue&type=script&lang=ts&setup=true"

import "./CreateMemberView.vue?vue&type=style&index=0&id=d92992f0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d92992f0"]])

export default __exports__